import type {I18nCode} from '../i18n'

/** `{name}` style placeholders, filled in. */
export const fill = (
  template: string,
  values: Record<string, string | number>
): string =>
  Object.entries(values).reduce(
    (s, [k, v]) => s.split(`{${k}}`).join(String(v)),
    template
  )

export function getI18nCommon(code: I18nCode) {
  if (code === 'en-US') {
    return {
      code,
      strings: {
        Refresh: 'Refresh',
        Search: 'Search...',
        Details: 'Details',
        Cancel: 'Cancel',
        Save: 'Save',
        Edit: 'Edit',
        Loading: 'Loading...',
        NoDataFound: 'No data found',
        Previous: 'Previous',
        Next: 'Next',
        PaginationOf: 'of {totalPages} ({totalCount} total)',
        PageLabel: 'Page {page} of {pages}',
        PerPage: 'Per page',

        StatusCompleted: 'Completed',
        StatusPlanned: 'Planned',
        StatusCancelled: 'Cancelled',
        StatusInProgress: 'In Progress',
        StatusLabel: 'Status',

        ColumnsLabel: 'Columns',
        ColumnsCustomize: 'Customize Columns',
        ColumnsReset: 'Reset',
        ColumnsDragHint: 'Drag to reorder, toggle visibility',

        SortEarliest: 'Pickup: Earliest first',
        SortLatest: 'Pickup: Latest first',

        DateToday: 'Today',
        DateTomorrow: 'Tomorrow',
        DateAll: 'All',
        DateCustom: 'Custom',

        NavDashboard: 'Dashboard',
        NavTransfers: 'Transfers',
        NavUsers: 'Users',
        NavFleet: 'Fleet',
        NavLocations: 'Locations',
        NavMyRides: 'My rides',
        NavMe: 'Me',
        NavBookings: 'Bookings',
        NavStatements: 'Billing',
        NavOffers: 'Offers',
        NavNotifications: 'Notifications',
        NoAccessTitle: 'No access',
        NoAccessBody:
          'Your account has no role in this app. Please contact the office.',
        AdminOnlyBody:
          'This page is for dispatch. Your rides and your account are in the menu.',
        CallerErrorTitle: 'Who are you?',
        CallerErrorBody: 'Your roles could not be read. Please try again.',

        Confirm: 'Confirm',
        Yes: 'Yes',
        No: 'No',
        Close: 'Close',
        Retry: 'Retry',
        ErrorTitle: 'Something went wrong',
        EmptyTitle: 'Nothing here',
        SavedSuccess: 'Saved',
        SaveFailed: 'Could not save',

        WeekdaySu: 'Su',
        WeekdayMo: 'Mo',
        WeekdayTu: 'Tu',
        WeekdayWe: 'We',
        WeekdayTh: 'Th',
        WeekdayFr: 'Fr',
        WeekdaySa: 'Sa'
      }
    }
  }

  if (code === 'tr-TR') {
    return {
      code,
      strings: {
        Refresh: 'Yenile',
        Search: 'Ara...',
        Details: 'Detaylar',
        Cancel: 'İptal',
        Save: 'Kaydet',
        Edit: 'Düzenle',
        Loading: 'Yükleniyor...',
        NoDataFound: 'Veri bulunamadı',
        Previous: 'Önceki',
        Next: 'Sonraki',
        PaginationOf: '{totalPages} sayfa ({totalCount} toplam)',
        PageLabel: 'Sayfa {page} / {pages}',
        PerPage: 'Sayfa başına',

        StatusCompleted: 'Tamamlandı',
        StatusPlanned: 'Planlandı',
        StatusCancelled: 'İptal edildi',
        StatusInProgress: 'Devam ediyor',
        StatusLabel: 'Durum',

        ColumnsLabel: 'Sütunlar',
        ColumnsCustomize: 'Sütunları özelleştir',
        ColumnsReset: 'Sıfırla',
        ColumnsDragHint: 'Sıralamak için sürükle, görünürlüğü değiştir',

        SortEarliest: 'Alış: En erken önce',
        SortLatest: 'Alış: En geç önce',

        DateToday: 'Bugün',
        DateTomorrow: 'Yarın',
        DateAll: 'Tümü',
        DateCustom: 'Özel',

        NavDashboard: 'Panel',
        NavTransfers: 'Transferler',
        NavUsers: 'Kullanıcılar',
        NavFleet: 'Filo',
        NavLocations: 'Konumlar',
        NavMyRides: 'Sürüşlerim',
        NavMe: 'Ben',
        NavBookings: 'Rezervasyonlar',
        NavStatements: 'Hesap',
        NavOffers: 'Teklifler',
        NavNotifications: 'Bildirimler',
        NoAccessTitle: 'Erişim yok',
        NoAccessBody:
          'Hesabınızın bu uygulamada bir rolü yok. Lütfen ofisle iletişime geçin.',
        AdminOnlyBody:
          'Bu sayfa sevkiyat içindir. Yolculuklarınız ve hesabınız menüdedir.',
        CallerErrorTitle: 'Siz kimsiniz?',
        CallerErrorBody: 'Rolleriniz okunamadı. Lütfen tekrar deneyin.',

        Confirm: 'Onayla',
        Yes: 'Evet',
        No: 'Hayır',
        Close: 'Kapat',
        Retry: 'Tekrar dene',
        ErrorTitle: 'Bir şeyler ters gitti',
        EmptyTitle: 'Burada bir şey yok',
        SavedSuccess: 'Kaydedildi',
        SaveFailed: 'Kaydedilemedi',

        WeekdaySu: 'Pz',
        WeekdayMo: 'Pt',
        WeekdayTu: 'Sa',
        WeekdayWe: 'Ça',
        WeekdayTh: 'Pe',
        WeekdayFr: 'Cu',
        WeekdaySa: 'Ct'
      }
    }
  }

  if (code === 'ar-EG') {
    return {
      code,
      strings: {
        Refresh: 'تحديث',
        Search: 'بحث...',
        Details: 'التفاصيل',
        Cancel: 'إلغاء',
        Save: 'حفظ',
        Edit: 'تعديل',
        Loading: 'جاري التحميل...',
        NoDataFound: 'لا توجد بيانات',
        Previous: 'السابق',
        Next: 'التالي',
        PaginationOf: 'من {totalPages} ({totalCount} إجمالي)',
        PageLabel: 'الصفحة {page} من {pages}',
        PerPage: 'لكل صفحة',

        StatusCompleted: 'مكتمل',
        StatusPlanned: 'مخطط',
        StatusCancelled: 'ملغى',
        StatusInProgress: 'قيد التنفيذ',
        StatusLabel: 'الحالة',

        ColumnsLabel: 'الأعمدة',
        ColumnsCustomize: 'تخصيص الأعمدة',
        ColumnsReset: 'إعادة تعيين',
        ColumnsDragHint: 'اسحب لإعادة الترتيب، بدّل الرؤية',

        SortEarliest: 'الاستلام: الأقدم أولاً',
        SortLatest: 'الاستلام: الأحدث أولاً',

        DateToday: 'اليوم',
        DateTomorrow: 'غداً',
        DateAll: 'الكل',
        DateCustom: 'مخصص',

        NavDashboard: 'لوحة التحكم',
        NavTransfers: 'الرحلات',
        NavUsers: 'المستخدمون',
        NavFleet: 'الأسطول',
        NavLocations: 'المواقع',
        NavMyRides: 'رحلاتي',
        NavMe: 'أنا',
        NavBookings: 'الحجوزات',
        NavStatements: 'الفوترة',
        NavOffers: 'العروض',
        NavNotifications: 'الإشعارات',
        NoAccessTitle: 'لا يوجد وصول',
        NoAccessBody:
          'حسابك ليس له دور في هذا التطبيق. يرجى التواصل مع المكتب.',
        AdminOnlyBody:
          'هذه الصفحة مخصصة لقسم الإرسال. رحلاتك وحسابك موجودان في القائمة.',
        CallerErrorTitle: 'من أنت؟',
        CallerErrorBody: 'تعذّر قراءة أدوارك. يرجى المحاولة مرة أخرى.',

        Confirm: 'تأكيد',
        Yes: 'نعم',
        No: 'لا',
        Close: 'إغلاق',
        Retry: 'إعادة المحاولة',
        ErrorTitle: 'حدث خطأ ما',
        EmptyTitle: 'لا يوجد شيء هنا',
        SavedSuccess: 'تم الحفظ',
        SaveFailed: 'تعذّر الحفظ',

        WeekdaySu: 'أحد',
        WeekdayMo: 'إثن',
        WeekdayTu: 'ثلا',
        WeekdayWe: 'أرب',
        WeekdayTh: 'خمي',
        WeekdayFr: 'جمع',
        WeekdaySa: 'سبت'
      }
    }
  }

  // de-AT (default)
  return {
    code,
    strings: {
      Refresh: 'Aktualisieren',
      Search: 'Suchen...',
      Details: 'Details',
      Cancel: 'Abbrechen',
      Save: 'Speichern',
      Edit: 'Bearbeiten',
      Loading: 'Laden...',
      NoDataFound: 'Keine Daten gefunden',
      Previous: 'Zurück',
      Next: 'Weiter',
      PaginationOf: 'von {totalPages} ({totalCount} gesamt)',
      PageLabel: 'Seite {page} von {pages}',
      PerPage: 'Pro Seite',

      StatusCompleted: 'Abgeschlossen',
      StatusPlanned: 'Geplant',
      StatusCancelled: 'Storniert',
      StatusInProgress: 'In Bearbeitung',
      StatusLabel: 'Status',

      ColumnsLabel: 'Spalten',
      ColumnsCustomize: 'Spalten anpassen',
      ColumnsReset: 'Zurücksetzen',
      ColumnsDragHint: 'Zum Umsortieren ziehen, Sichtbarkeit umschalten',

      SortEarliest: 'Abholung: Früheste zuerst',
      SortLatest: 'Abholung: Späteste zuerst',

      DateToday: 'Heute',
      DateTomorrow: 'Morgen',
      DateAll: 'Alle',
      DateCustom: 'Benutzerdefiniert',

      NavDashboard: 'Dashboard',
      NavTransfers: 'Transfers',
      NavUsers: 'Benutzer',
      NavFleet: 'Flotte',
      NavLocations: 'Standorte',
      NavMyRides: 'Meine Fahrten',
      NavMe: 'Ich',
      NavBookings: 'Buchungen',
      NavStatements: 'Abrechnung',
      NavOffers: 'Angebote',
      NavNotifications: 'Benachrichtigungen',
      NoAccessTitle: 'Kein Zugang',
      NoAccessBody:
        'Ihr Konto hat in dieser App keine Rolle. Bitte wenden Sie sich an das Büro.',
      AdminOnlyBody:
        'Diese Seite ist für die Disposition. Ihre Fahrten und Ihr Konto finden Sie im Menü.',
      CallerErrorTitle: 'Wer sind Sie?',
      CallerErrorBody:
        'Ihre Rollen konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',

      Confirm: 'Bestätigen',
      Yes: 'Ja',
      No: 'Nein',
      Close: 'Schließen',
      Retry: 'Erneut versuchen',
      ErrorTitle: 'Etwas ist schiefgelaufen',
      EmptyTitle: 'Hier ist nichts',
      SavedSuccess: 'Gespeichert',
      SaveFailed: 'Speichern fehlgeschlagen',

      WeekdaySu: 'So',
      WeekdayMo: 'Mo',
      WeekdayTu: 'Di',
      WeekdayWe: 'Mi',
      WeekdayTh: 'Do',
      WeekdayFr: 'Fr',
      WeekdaySa: 'Sa'
    }
  }
}
